<template>

  <el-form :inline="true" label-position="top">
        <el-form-item label="AGL">
            <el-input-number class="input" type="number" v-model="equip.agl" placeholder="AGL" :disabled="!this.isEdit" />
        </el-form-item>

        <el-form-item label="Height On Tower">
          <el-input-number class="input" type="number" v-model="equip.heightOnTower" placeholder="Height on Tower" :disabled="!this.isEdit" />
        </el-form-item>

        <el-form-item label="Sector">
          <el-input-number class="input" type="number" v-model="equip.sector" placeholder="Sector" :disabled="!this.isEdit" />
        </el-form-item>

      <el-form-item label="Level">
          <el-input-number class="input" type="number" v-model="equip.level" placeholder="Level" :disabled="!this.isEdit" />
        </el-form-item>

  </el-form>

</template>


<script>

export default {

  props: {
    rowData: {
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      equip: this.rowData
    }
  } // data
}
</script>



// WEBPACK FOOTER //
// OnTower.vue?14403784